import Api from '../Api';

export interface MailValues {
  topic: string;
  subTopic?: string;
  name: string;
  email: string;
  body: string;
  subject: string;
  orderNumber: string;
  lineItemIds?: string;
  attachments?: Attachment[];
}

export interface Attachment {
  id: string;
  href: string;
  contentType: string;
  fileName: string;
  size?: string;
}

class HelpCenterService extends Api {
  /**
   * Send a mail to customer care
   */
  async sendMail({
    topic, subTopic, name, email, body, subject, orderNumber, lineItemIds, attachments,
  }: MailValues, origin: string, locale: string, store: string) {
    await this.httpClient.post('/send-mail', {
      formData: {
        topic,
        subTopic: typeof subTopic === 'string' ? parseInt(subTopic, 10) : subTopic,
        name,
        email,
        body,
        subject,
        orderNumber,
        lineItemIds,
        attachments,
      },
      origin,
      locale,
      store,
    });
  }
}

export { HelpCenterService };
